<template>
  <div class="nx-searcher-filter-dates pl-4 pr-4">
    <nx-searcher-filter-unique-checkbox
        :value="optValue"
        :disabled="disabled"
        :options="computedOptions"
        @input="changeOpt"
        filter="dates"
    ></nx-searcher-filter-unique-checkbox>

    <v-slide-y-transition>
      <v-layout row v-show="optValue === 'range'">
        <v-flex xs6 class="mr-2">
          <nx-date-picker
              v-model="fromDate"
              name="fromDate"
              :disabled="disabled"
              :label="$t('message.searcher.filters.values.dates.from')"
              @input="dateSelected($event, 'from')"
              :autoclose="false"
          ></nx-date-picker>
        </v-flex>
        <v-flex xs6>
          <nx-date-picker
              v-model="toDate"
              name="fromDate"
              :disabled="disabled"
              :label="$t('message.searcher.filters.values.dates.to')"
              @input="dateSelected($event, 'to')"
              :autoclose="false"
          ></nx-date-picker>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </div>
</template>

<script>
import moment from 'moment';
import Filter from './Filter';
import NxSearcherFilterUniqueCheckbox from './UniqueCheckbox';

export default {
  name: 'nx-searcher-filter-dates',
  extends: Filter,
  components: {
    NxSearcherFilterUniqueCheckbox,
    NxDatePicker: () => import('@/components/date/DatePicker'),
  },
  props: {
    options: {
      type: Array,
    },
  },
  data() {
    return {
      format: 'YYYY-MM-DD',
      optValue: null,
      fromDate: null,
      toDate: null,
      defaultOptions: [
        'lastDay',
        'lastWeek',
        'range',
      ],
    };
  },
  computed: {
    computedOptions() {
      return this.options || this.defaultOptions;
    },
  },
  methods: {
    changeOpt(filter, value) {
      this.optValue = value;
      if (value !== 'range') {
        this.updateFilter(value);
        this.fromDate = null;
        this.toDate = null;
      }
    },
    dateSelected() {
      this.updateFilter([
        (this.fromDate) ? moment(this.fromDate).format(this.format) : null,
        (this.toDate) ? moment(this.toDate).format(this.format) : null,
      ]);
    },
  },
  mounted() {
    if (typeof this.value === 'string') {
      this.optValue = this.value;
    } else if (Array.isArray(this.value)) {
      this.optValue = 'range';
      this.fromDate = this.value[0];
      this.toDate = this.value[1];
    }
  },
};
</script>

<style lang="stylus">
.nx-searcher-filter-dates {

  margin-bottom: 12px;

  .v-input__slot {
    margin-bottom: 0
  }
  .v-messages {
    display: none;
  }
}
</style>
